import axios from "axios";

const api = axios.create({
    baseURL: "https://imagensdaface.com.br/api/v1"
});

/**
 * 💡 LISTA DE EXCEÇÕES:
 * Rotas que podem retornar 401 (por erro de config do backend) 
 * mas que NÃO devem deslogar o usuário no frontend.
 */
const BYPASS_LOGOUT_URLS = [
    "/admin/publications",
    "/forum/threads",
    "/settings/public"
];

// ======================================================
// 🔥 INTERCEPTOR DE REQUEST
// ======================================================
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        // Envia o token se existir, permitindo que o backend valide se necessário
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Gerenciamento de Content-Type para Uploads (FormData)
        if (config.data instanceof FormData) {
            delete config.headers["Content-Type"];
        } else {
            config.headers["Content-Type"] = "application/json";
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ======================================================
// 🔥 INTERCEPTOR DE RESPONSE (401 → logout com filtros)
// ======================================================
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        const triggerExpiration = window.sessionCallbacks?.triggerExpiration;

        if (status === 401) {
            const isLoginPage = window.location.pathname.includes("/login");
            const hasToken = !!localStorage.getItem("token");

            // Verifica se a URL que deu erro está na lista de exceções (Bypass)
            const shouldBypass = BYPASS_LOGOUT_URLS.some(path => url.includes(path));

            // SÓ desloga se:
            // 1. Tiver token (usuário estava logado antes)
            // 2. Não for a página de login
            // 3. NÃO for uma rota da lista de exceções
            if (hasToken && !isLoginPage && !shouldBypass && triggerExpiration) {
                triggerExpiration();
            }
        }

        return Promise.reject(error);
    }
);

export default api;